export const formularKeys = {
  einstellungsformular: 'employee.checkin',
  accidentreport: 'employee.accidentreport',
  evaluation: 'employee.evaluation',
  docket: 'employee.docket',
}

const formulars = [
  {
    key: formularKeys.einstellungsformular,
    page: 'public.formular.employee.checkin'
  },
  {
    key: formularKeys.accidentreport,
    page: 'public.formular.employee.accidentreport'
  },
  {
    key: formularKeys.evaluation,
    page: 'public.formular.employee.evaluation'
  },
  {
    key: formularKeys.docket,
    page: 'public.formular.employee.docket'
  }
]


export default {
  getFormularPage: (formularKey) => {
    return formulars.find(f => f.key === formularKey)?.page
  }
}
